import React from 'react'
import axios from 'axios'
import StorageUtils from '../../utils/StorageUtils'
import MemoryUtils from '../../utils/MemoryUtils'
import { Redirect } from 'react-router-dom'
import { reqLogout } from '../../api'

class Logout extends  React.Component {
    logout = async () => {
        const { refresh } = StorageUtils.getUser()
        const result = await reqLogout(refresh)
    }

    render(){
        this.logout()
        StorageUtils.removeUser()
        MemoryUtils.user = ''

        return (
            <Redirect to='/' />
        )
    }
}

export default Logout